import React from "react";
import parse from 'html-react-parser';
import Button from "./Button";
import styles from "../styles/PartnerLandingContent.module.css";

const PartnerLandingContent = ({ title, bodyHtml, body, imageSrc, dismissLabel = "Entra", onDismiss }) => {
  const normalizedBodyHtml = typeof bodyHtml === 'string' ? bodyHtml.trim() : '';

  return (
    <div className={styles.container}>
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={title || "Benvenuto"}
          className={styles.image}
        />
      ) : null}
      {normalizedBodyHtml ? (
        <div className={styles.body}>{parse(normalizedBodyHtml)}</div>
      ) : body != null && body !== false ? (
        typeof body === 'string' || typeof body === 'number' ? (
          <p className={styles.paragraph}>{body}</p>
        ) : (
          <div className={styles.body}>{body}</div>
        )
      ) : null}
      <div className={styles.buttonRow}>
        <Button primary onClick={onDismiss}>
          {dismissLabel}
        </Button>
      </div>
    </div>
  );
};

export default PartnerLandingContent;

